import * as React from 'react';

type PreviewImage = {
    id: number;
    src: string;
    filename: string;
    categoryId: number;
};

type UsePreviewFilenameParams = {
    previewImage: PreviewImage | null;
    setPreviewImage: React.Dispatch<React.SetStateAction<PreviewImage | null>>;
    updateCachedFilename: (imageId: number, newFilename: string) => void;
    updateImageFilename: (imageId: number, newFilename: string) => void;
};

export function usePreviewFilename({
    previewImage,
    setPreviewImage,
    updateCachedFilename,
    updateImageFilename
}: UsePreviewFilenameParams) {
    function savePreviewFilename(newFilename: string) {
        if (!previewImage) {
            return;
        }

        // Optimistically update preview dialog state
        setPreviewImage(function (prev) {
            if (prev) {
                return {
                    id: prev.id,
                    src: prev.src,
                    filename: newFilename,
                    categoryId: prev.categoryId
                };
            }
            return prev;
        });

        // Optimistically update preview cache
        updateCachedFilename(previewImage.id, newFilename);

        // Optimistically update the image card in the grid
        updateImageFilename(previewImage.id, newFilename);
    }

    return {
        savePreviewFilename
    };
}
